export const plans = {
    annual: "price_1NmzsnCicdBkxfKhxKfssZjv",
    monthly: "price_1OCnd6CicdBkxfKhGaLTBLCE",
    semiannual: "price_1NmzsnCicdBkxfKh3An4PrJg"
}

export const plansPrices = {
    monthly: "R$ 99,00",
    semiannual: "R$ 474,00",
    annual: "R$ 828,00"
}

export const rawPlanPrices = {
    monthly: 99.00,
    semiannual: 474.00,
    annual: 828.00
} as const

export const plansName = {
    monthly: "Mensal",
    semiannual: "Semianual",
    annual: "Anual"
}

export const plansMonths = {
    monthly: "mês",
    semiannual: "6 meses",
    annual: "12 meses"
}